export * from "./types";

export * from "./demoData";
export * from "./realData";

import { SceneId, Scenes } from ".";

export interface GameData {
    scenes: Scenes;
    initialSceneId: SceneId;
}
